import { MediaFragment } from 'generated/graphql';
import * as styles from './CreatorApprovedSwaps.css';

export const SwapThumb = ({ media }: { media?: MediaFragment | null }) => {
  const src = media?.videoThumbnailUrl || media?.image || media?.cdn01;
  return src ? (
    <img className={styles.thumb} src={src} alt="" />
  ) : (
    <div className={styles.thumb} />
  );
};
